module.exports = __webpack_public_path__ + "media/images/common/guide_btn-fb159890a6d9969ad084b4c09cbb375a.gif";